import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { defaultState } from './index';

const mutationGenerator = () => ({
  params: { $set: defaultState.params },
  result: { $set: defaultState.result },
  slugs: { $set: defaultState.slugs },
  categories: { $set: defaultState.categories },
  numbers: { $set: defaultState.numbers },
  entities: { $set: defaultState.entities },
  status: { $set: defaultState.status },
  error: { $set: defaultState.error },
});

export const linearChannelsResetReducer = (currentState, action) =>
  updateState(currentState, mutationGenerator(payloadExtractor(action)));
